<template>
  <v-menu
    location="bottom end"
    offset="10"
    :close-on-content-click="true"
    transition="scale-transition"
  >
    <template #activator="{ props: menuProps }">
      <div v-bind="menuProps" class="app-bar-profile">
        <div class="app-bar-profile__avatar">{{ initials }}</div>
        <div class="app-bar-profile__meta">
          <span class="app-bar-profile__name">{{ displayName }}</span>
          <span class="app-bar-profile__role">{{ roleLabel }}</span>
        </div>
        <v-icon icon="mdi-chevron-down" size="18" class="app-bar-profile__chevron" />
      </div>
    </template>

    <div class="profile-menu" role="menu" aria-label="Account menu">
      <div class="profile-menu__header">
        <div class="profile-menu__header-bg" aria-hidden="true" />
        <div class="profile-menu__identity">
          <div class="profile-menu__avatar-wrap">
            <span class="profile-menu__avatar">{{ initials }}</span>
            <span class="profile-menu__status" title="Active session" aria-hidden="true" />
          </div>
          <div class="profile-menu__details">
            <span class="profile-menu__name">{{ displayName }}</span>
            <span v-if="email" class="profile-menu__email">{{ email }}</span>
            <span class="profile-menu__role-pill">{{ roleLabel }}</span>
          </div>
        </div>
        <p v-if="orgName" class="profile-menu__org">
          <v-icon icon="mdi-domain" size="14" class="profile-menu__org-icon" />
          {{ orgName }}
        </p>
      </div>

      <div class="profile-menu__body">
        <button
          type="button"
          class="profile-menu__action profile-menu__action--signout"
          role="menuitem"
          @click="$emit('sign-out')"
        >
          <span class="profile-menu__action-icon profile-menu__action-icon--signout">
            <v-icon icon="mdi-logout" size="18" />
          </span>
          <span class="profile-menu__action-text">
            <span class="profile-menu__action-title">Sign out</span>
            <span class="profile-menu__action-desc">End your portal session securely</span>
          </span>
          <v-icon icon="mdi-chevron-right" size="18" class="profile-menu__action-chevron" />
        </button>
      </div>

      <footer class="profile-menu__footer">
        <v-icon icon="mdi-shield-check-outline" size="14" />
        <span>Encrypted session · Enterprise grade security</span>
      </footer>
    </div>
  </v-menu>
</template>

<script setup>
defineOptions({ name: 'AppBarProfileMenu' })

defineProps({
  displayName: {
    type: String,
    default: '—',
  },
  email: {
    type: String,
    default: '',
  },
  roleLabel: {
    type: String,
    default: 'Team member',
  },
  orgName: {
    type: String,
    default: '',
  },
  initials: {
    type: String,
    default: 'YA',
  },
})

defineEmits(['sign-out'])
</script>
